// extracted by mini-css-extract-plugin
module.exports = {"icon":"Tooltip_icon__1c1E-","tooltip":"Tooltip_tooltip__23jSo","tooltiptext":"Tooltip_tooltiptext__3VkRU"};